import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Button, Form, Modal, Popconfirm, Input, AutoComplete, Icon, message, Tooltip } from 'antd'
import ReactTable from 'react-table'
import moment from 'moment'
import Loader from '../../common/Loader'
import { actions as jobSiteWorkOrderActions } from '../../../redux/modules/jobFunctions/jobSiteWorkOrderActions'
import { actions as workOrderTemplatesActions } from '../../../redux/modules/jobFunctions/workOrderTemplatesActions'
import { actions as tasksActions } from '../../../redux/modules/tasksActions'
import { actions as userActions } from '../../../redux/modules/userActions'
import WorkOrderEditor from '../../../components/WorkOrderEditor'
import {
  filterCaseInsensitive,
  convertToOption,
  convertNamesToOption,
  arrayMove,
  getModalId
} from '../../../util'
import config from '../../../config'
import _ from 'lodash'
import history from '../../../history'

const { API_BASE } = config
const FormItem = Form.Item
const { TextArea } = Input
const propTypes = {}

class JobSiteWorkOrders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: getModalId(props.location.pathname),
      contentData: null,
      workOrderItems: []
    }

    this.props.jobSiteWorkOrdersRefresh({
      jobId: this.props.jobId,
      next: (payload, err) => {
        const changeOrderId = getModalId(this.props.location.pathname)
        if (changeOrderId) {
          if (!err) {
            const results = _.get(payload, 'data')
            const current = _.find(results, { id: parseInt(changeOrderId, 10) })
            if (current) {
              setTimeout(() => this.handleRowClick(current), 500)
            } else {
              message.warning('This Purchase Order was deleted or does not exist.')
            }
          }
        }
      }
    })
    this.props.getAllTasks()
    this.props.getWorkOrderTemplates()
    this.props.getUsers()
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.workOrderTemplatesActions.workOrderTemplateItems !==
      this.props.workOrderTemplatesActions.workOrderTemplateItems
    ) {
      this.setState({
        workOrderItems: this.props.workOrderTemplatesActions.workOrderTemplateItems.data
      })
    }

    if (
      prevProps.jobSiteWorkOrderActions.jobSiteWorkOrdersItems !==
      this.props.jobSiteWorkOrderActions.jobSiteWorkOrdersItems
    ) {
      this.setState({
        workOrderItems: this.props.jobSiteWorkOrderActions.jobSiteWorkOrdersItems.data
      })
    }
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      if (this.state.currentId === 0) {
        this.props.createWorkOrder({
          jobId: this.props.jobId,
          content: values,
          workOrderItems: this.state.workOrderItems,
          userId: this.props.user.userId
        })
      } else {
        if (isNaN(values.assigned_to_id)) {
          values.assigned_to_id = this.props.userActions.users.data.filter(
            item => `${item.first_name} ${item.last_name}` === values.assigned_to_id
          )[0].id
        }
        if (!Number.isInteger(values.work_order_template_id)) {
          values.work_order_template_id = this.state.contentData.work_order_template_id
        }
        this.props.updateWorkOrder({
          workOrderId: this.state.currentId,
          jobId: this.props.jobId,
          content: values,
          workOrderItems: this.state.workOrderItems,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      const { jobId, jobType } = this.props.match.params
      history.push(`/jobView/${jobId}/${jobType}/work-orders`)
      this.setState({ contentData: null, currentId: 0 })
    })
  }

  handleRowClick = row => {
    this.setState({
      currentId: row.id,
      contentData: row
    })
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/work-orders/modal/${row.id}`)
    this.props.getWorkOrderItems(row.id)
  }

  handleAddButton = () => {
    this.props.form.resetFields()
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/work-orders/modal/0`)
    this.setState({
      currentId: 0,
      contentData: null,
      workOrderItems: []
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/work-orders`)
    this.setState({
      currentId: 0,
      contentData: null,
      workOrderItems: [],
      addTaskName: ''
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteWorkOrder({
      jobId: this.props.jobId,
      workOrderId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    const { jobId, jobType } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/work-orders`)
    this.setState({
      contentData: null,
      currentId: 0,
      workOrderItems: []
    })
  }

  handleItemsChange = workOrderItems => {
    this.setState({
      workOrderItems
    })
  }

  handleInputChange = (value, key, column) => {
    const groupedItems = this.state.workOrderItems.map(row => {
      if (row.id === key) row[column] = value
      return row
    })
    this.setState({
      workOrderItems: groupedItems
    })
  }

  editChangeOrderRow = rowId => {
    const groupedItems = this.state.workOrderItems.map(row => {
      if (row.id === rowId) row.isEditingRow = true
      return row
    })
    this.setState({
      workOrderItems: groupedItems
    })
  }

  saveChangeOrderRow = rowId => {
    const groupedItems = this.state.workOrderItems.map(row => {
      if (row.id === rowId) {
        row.isEditingRow = false
      }
      return row
    })
    this.setState({
      workOrderItems: groupedItems
    })
  }

  deleteChangeOrderRow = rowId => {
    const groupedItems = this.state.workOrderItems.filter(item => item.id !== rowId)

    this.setState({
      workOrderItems: groupedItems
    })
  }

  handleAddTaskInputChange = value => {
    const selectedTask = this.props.tasksActions.allTasks.data.filter(
      row => parseInt(row.id, 0) === parseInt(value, 0)
    )
    if (selectedTask.length > 0) {
      this.setState({
        addTaskInput: value,
        addTaskName: selectedTask[0].name
      })
    } else {
      this.setState({
        addTaskInput: value,
        addTaskName: value
      })
    }
  }

  handleAddDeviceNumberInputChange = value => {
    this.setState({
      addDeviceNumberInput: value
    })
  }

  handleAddMaterialsNeededInputChange = value => {
    this.setState({
      addMaterialsNeededInput: value
    })
  }

  handleAddItemClick = () => {
    const groupedItems = this.state.workOrderItems

    if (
      _.isEmpty(this.state.addTaskInput) ||
      _.isEmpty(this.state.addDeviceNumberInput) ||
      _.isEmpty(this.state.addMaterialsNeededInput)
    ) {
      message.warning('You need to fill all item informations.')
    } else {
      const taskId = `item_${groupedItems.length + 1}`
      groupedItems.push({
        task_id: this.state.addTaskInput,
        task_name: this.state.addTaskName,
        device_number: this.state.addDeviceNumberInput,
        materials_needed: this.state.addMaterialsNeededInput,
        id: taskId
      })
      this.setState({
        workOrderItems: groupedItems,
        addTaskInput: '',
        addTaskName: '',
        addDeviceNumberInput: '',
        addMaterialsNeededInput: ''
      })
    }
  }

  handleTemplateChange = event => {
    const form = this.props.form
    const selectedTemplate = this.props.workOrderTemplatesActions.workOrderTemplates.data.filter(
      row => parseInt(row.id, 0) === parseInt(event, 0)
    )
    if (selectedTemplate.length > 0) {
      this.props.getWorkOrderTemplateItems(selectedTemplate[0].id)
      form.setFieldsValue({
        description: selectedTemplate[0].description,
        work_order_template_id: selectedTemplate[0].id
      })
    }
  }

  markTaskComplete = taskId => {
    this.setState(prevState => {
      const taskIndex = prevState.workOrderItems.findIndex(task => task.id === taskId)
      let prevItems = [...prevState.workOrderItems]
      prevItems[taskIndex].completed = 1
      return { workOrderItems: prevItems }
    })

    this.props.markTaskComplete({
      jobId: this.props.jobId,
      taskId: taskId,
      workOrderId: this.state.currentId
    })
  }

  handleItemUp = taskId => {
    const { workOrderItems } = this.state
    const taskIndex = workOrderItems.findIndex(task => task.id === taskId)
    const sortedItemDataStructure = arrayMove(workOrderItems, taskIndex, taskIndex - 1)

    this.setState({
      workOrderItems: sortedItemDataStructure
    })
  }

  handleItemDown = taskId => {
    const { workOrderItems } = this.state
    const taskIndex = workOrderItems.findIndex(task => task.id === taskId)
    const sortedItemDataStructure = arrayMove(workOrderItems, taskIndex, taskIndex + 1)

    this.setState({
      workOrderItems: sortedItemDataStructure
    })
  }

  handleQuickAddTask = task => {
    this.props.quickAddTask({
      task: task,
      userId: this.props.user.userId
    })
  }

  shouldRenderModal = () => {
    return /modal\/\d+$/.test(window.location.href)
  }

  render() {
    const { contentData } = this.state
    const { getFieldDecorator } = this.props.form

    if (!this.props.jobSiteWorkOrderActions.jobSiteWorkOrders) {
      return <Loader />
    }
    return (
      <div>
        {this.shouldRenderModal() && (
          <Modal
            visible={true}
            title="Work Orders"
            okText={contentData ? 'Save Changes' : 'Create'}
            onCancel={this.handleCancel}
            onOk={this.handleCreate}
            width={1020}
            maskClosable={false}
          >
            <Form layout="vertical">
              {contentData && (
                <div className="row">
                  <div className="col-md-12 text-right">
                    <a
                      href={`${API_BASE}/api/job/job_site_work_orders/print/${contentData.id}`}
                      target="_blank"
                    >
                      <Button icon="printer" className="marginRight10" />
                    </a>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-md-12">
                  <FormItem label="Template">
                    {getFieldDecorator('work_order_template_id', {
                      initialValue: contentData ? contentData.template_name : ''
                    })(
                      <AutoComplete
                        dataSource={convertToOption(
                          this.props.workOrderTemplatesActions &&
                            this.props.workOrderTemplatesActions.workOrderTemplates &&
                            this.props.workOrderTemplatesActions.workOrderTemplates.data
                        )}
                        filterOption={(inputValue, option) =>
                          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                          -1
                        }
                        onChange={this.handleTemplateChange}
                      >
                        <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                      </AutoComplete>
                    )}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Requested By">
                    {getFieldDecorator('requested_by', {
                      rules: [
                        {
                          required: true,
                          message: 'Requested by cannot be blank.'
                        }
                      ],
                      initialValue: contentData ? contentData.requested_by : ''
                    })(<Input />)}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="Assigned To">
                    {getFieldDecorator('assigned_to_id', {
                      rules: [
                        {
                          required: true,
                          message: 'Assigned to cannot be blank.'
                        }
                      ],
                      initialValue: contentData
                        ? `${contentData.assigned_to_first_name} ${
                            contentData.assigned_to_last_name
                          }`
                        : ''
                    })(
                      <AutoComplete
                        dataSource={convertNamesToOption(
                          this.props.userActions &&
                            this.props.userActions.users &&
                            this.props.userActions.users.data
                        )}
                        filterOption={(inputValue, option) =>
                          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                          -1
                        }
                      >
                        <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                      </AutoComplete>
                    )}
                  </FormItem>
                </div>
              </div>
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  initialValue: contentData ? contentData.description : ''
                })(<TextArea placeholder="Describe the attachment..." rows={4} />)}
              </FormItem>
              <WorkOrderEditor
                allTasks={
                  this.props.tasksActions &&
                  this.props.tasksActions.allTasks &&
                  this.props.tasksActions.allTasks.data
                }
                workOrderItems={this.state.workOrderItems}
                handleItemsChange={this.handleItemsChange}
                editRow={this.editChangeOrderRow}
                saveRow={this.saveChangeOrderRow}
                deleteRow={this.deleteChangeOrderRow}
                handleItemUp={this.handleItemUp}
                handleItemDown={this.handleItemDown}
                handleAddTaskInputChange={this.handleAddTaskInputChange}
                handleAddDeviceNumberInputChange={this.handleAddDeviceNumberInputChange}
                handleAddMaterialsNeededInputChange={this.handleAddMaterialsNeededInputChange}
                handleAddItemClick={this.handleAddItemClick}
                handleInputChange={this.handleInputChange}
                addTaskInput={this.state.addTaskInput}
                addTaskName={this.state.addTaskName}
                addDeviceNumberInput={this.state.addDeviceNumberInput}
                addMaterialsNeededInput={this.state.addMaterialsNeededInput}
                nextStep={() => this.nextStep()}
                prevStep={() => this.prevStep()}
                isNew={!contentData}
                markTaskComplete={this.markTaskComplete}
                handleQuickAddTask={this.handleQuickAddTask}
              />
              <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={this.confirmDelete}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
              >
                {contentData && <Button type="danger" icon="delete" />}
              </Popconfirm>
            </Form>
          </Modal>
        )}
        <div className="jobsBar">
          Work Order
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Order
            </div>
          </div>
        </div>
        {this.props.jobSiteWorkOrderActions.jobSiteWorkOrders && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={this.props.jobSiteWorkOrderActions.jobSiteWorkOrders.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Number',
                    accessor: 'number',
                    maxWidth: 90,
                    filterable: false
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Completed',
                    className: 'textAlignCenter',
                    Cell: row => {
                      if (row.original.completed === 0) {
                        return <Icon type="close-circle" />
                      }
                      if (row.original.completed === 1) {
                        return <Icon type="check-circle-o" />
                      }
                    },
                    maxWidth: 90,
                    filterable: false
                  },
                  {
                    Header: 'Completed Date',
                    id: 'completed_date',
                    accessor: d => {
                      if (moment(d.completed_date).isValid() && d.completed) {
                        return moment(d.completed_date, 'YYYY-MM-DD hh:mm:ss').format(
                          'M/D/YYYY h:mm:ssa'
                        )
                      } else {
                        return 'Not yet complete'
                      }
                    },
                    maxWidth: 200
                  },
                  {
                    Header: 'Created Date',
                    id: 'created_date',
                    accessor: d => moment(d.created_date).format('M/D/YYYY h:mm:ssa'),
                    maxWidth: 200
                  },
                  {
                    Header: 'Created By',
                    id: 'created_by',
                    Cell: d => (
                      <Tooltip
                        title={`${d.original.created_by_first_name} ${
                          d.original.created_by_last_name
                        }`}
                      >{`${d.original.created_by_first_name} ${
                        d.original.created_by_last_name
                      }`}</Tooltip>
                    )
                  },
                  {
                    Header: 'Updated by',
                    id: 'updated_by',
                    Cell: d => (
                      <Tooltip
                        title={`${d.original.updated_by_first_name} ${
                          d.original.updated_by_last_name
                        }`}
                      >{`${d.original.updated_by_first_name} ${
                        d.original.updated_by_last_name
                      }`}</Tooltip>
                    )
                  }
                ]
              }
            ]}
            defaultSorted={[
              {
                id: 'id',
                desc: true
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (
  { jobSiteWorkOrderActions, tasksActions, workOrderTemplatesActions, userActions },
  ownProps
) => ({
  jobSiteWorkOrderActions,
  tasksActions,
  workOrderTemplatesActions,
  userActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign(
      {},
      tasksActions,
      jobSiteWorkOrderActions,
      workOrderTemplatesActions,
      userActions
    ),
    dispatch
  )
})

JobSiteWorkOrders.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobSiteWorkOrders))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobSiteWorkOrders.js